import * as React from "react"
import type { SVGProps } from "react"
const SvgSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.29a10 10 0 0 1-3.9-.8 10 10 0 0 1-3.17-2.13 10 10 0 0 1-2.14-3.17 10 10 0 0 1-.79-3.9q0-2.09.79-3.9A10 10 0 0 1 4.92 5.2Q6.28 3.86 8.1 3.07A10 10 0 0 1 12 2.3q2.07 0 3.9.78a10 10 0 0 1 3.18 2.14q1.34 1.35 2.13 3.18a10 10 0 0 1 .79 3.9 10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.17q-1.34 1.35-3.17 2.14a10 10 0 0 1-3.9.78m-2.9-2.55 1.2-2.75a5 5 0 0 1-1.81-1.17A6 6 0 0 1 7.3 14l-2.75 1.15q.57 1.6 1.78 2.8 1.2 1.2 2.77 1.8M7.3 10.6q.42-1.05 1.19-1.84A5 5 0 0 1 10.3 7.6L9.15 4.84a7.8 7.8 0 0 0-4.6 4.6zm4.7 4.7q1.25 0 2.13-.88A3 3 0 0 0 15 12.3q0-1.26-.87-2.13A3 3 0 0 0 12 9.3q-1.25 0-2.12.87A3 3 0 0 0 9 12.3q0 1.25.88 2.12a3 3 0 0 0 2.12.88m2.9 4.45a8 8 0 0 0 2.76-1.8 8 8 0 0 0 1.79-2.75L16.7 14q-.37 1.05-1.15 1.8a6 6 0 0 1-1.8 1.2zm1.8-9.2 2.75-1.15a8 8 0 0 0-1.79-2.77 8 8 0 0 0-2.76-1.78l-1.15 2.8q1.02.38 1.78 1.13c.76.75.89 1.1 1.17 1.77" />
  </svg>
)
export default SvgSupport
